import React, { useState, useEffect, useContext } from 'react';
import { Form, Input, Select, DatePicker, message } from 'antd';
import axios from "../../../common/axios";
import SyllabusTopicConceptSelect from "../../../common/SyllabusTopicConceptSelect";
import {UserContext} from "../../../common/UserContext";
import {BrandContext} from "../../../common/BrandContext";
import ClassSelect from "../../../common/ClassSelect";
import TestResultBarGraph from "./TestResultBarGraph";
import TestResult from "../../student/assessments/TestResult";
import TableFilterControls from "../../../common/TableFilterControls";
import TableAntD from "../../../common/TableAntD";
import GenericDialog from "../../../common/GenericDialog";
import TableFilterControlsForm from "../../../common/TableFilterControlsForm";
import TableFilterControlsSection from "../../../common/TableFilterControlsSection";
import TestQuestion from "../../student/assessments/TestQuestion";
import {useFormFilterBadge} from "../../../hooks/useFormFilterBadge";
import {useScreenReaderAnnouncement} from "../../../hooks/useScreenReaderAnnouncment";

const { Option } = Select;
const { RangePicker } = DatePicker;

const TeacherTestResults = (props) => {
    const {user} = useContext(UserContext),
        brandConfig = useContext(BrandContext),
        [testResultSearchForm] = Form.useForm(),
        [exam, setExam] = useState(false),
        classId = Form.useWatch('classId', testResultSearchForm),
        [testGroupCode, setTestGroupCode] = useState(),
        [testAssignmentStatus, setTestAssignmentStatus] = useState('ALL'),
        // [orderBy, setOrderBy] = useState('CREATED_DESC'),
        // [testResults, setTestResults] = useState([]),
        // [testResultsCount, setTestResultsCount] = useState(0),
        [testResultId, setTestResultId] = useState(),
        [visibleSection, setVisibleSection] = useState('TEST_RESULTS'),
        [testGroups,setTestGroups] = useState([]),
        [students, setStudents] = useState([]),
        [studentId, setStudentId] = useState(),
        [isTestGroupsLoading, setTestGroupsLoading] = useState(true),
        [reload, setReload] = useState(),
        [questionResultDialogOpen, setQuestionResultDialogOpen] = useState(false),
        [question, setQuestion] = useState(),
        [questionResult, setQuestionResult] = useState(),
        {activeFilterCount, onLoadComplete, handleValuesChange: handleBadgeValuesChange} = useFormFilterBadge(testResultSearchForm),
        { setSrAnnouncement, LiveRegion, srAnnouncement } = useScreenReaderAnnouncement();

    globalReactFunctions.refreshTeacherTestResults = () => {
        setReload(new Date().getTime());
    };

    const handleOpenDialog = (locQuestion, locQuestionResult)=>{
        setQuestion(locQuestion);
        setQuestionResult(locQuestionResult);
        if(locQuestion && locQuestionResult) {
            setQuestionResultDialogOpen(true);
        }
    }

    useEffect(()=>{
        if(brandConfig.testGroupCodes){
            setTestGroupsLoading(true);
            axios.get('/web/ui/test/testGroups')
                .then(response => {
                    if (response.data) {
                        setTestGroups(response.data);
                    } else {
                        setTestGroups([]);
                    }
                }).finally(()=>{
                setTestGroupsLoading(false)
            });
        }
    },[]);

    useEffect(() => {
        if(classId != undefined) {
            axios.get('/web/ui/sc/studentsInClass', {params: {classId: classId}})
                .then(response => {
                    if (response.data) {
                        setStudents(response.data);
                    } else {
                        setStudents([]);
                        setStudentId(undefined);
                    }
                });
        } else {
            setStudents([]);
            setStudentId(undefined);
        }
    }, [classId]);

    const columns = [
        {
            title: brandConfig.testName + ' and Student',
            dataIndex: 'name',
            sorter: false,
            render: (_, record) => <><a className={'ch-link'} aria-label={'view '+(record.testName ? record.testName:brandConfig.testName)+ ' result'} tabIndex={0} onClick={() => handleViewTestResult(record)}>{record.testName ? record.testName : <span className="ch-empty-name">{'[' + brandConfig.testName + ' name]'}</span>}</a><br/>{record.fullName}</>
        },
        {
            title: <span style={{whiteSpace: 'nowrap'}}>Score</span>,
            dataIndex: 'mark',
            align: 'center',
            render: (_, record) => record.mark != undefined ? (record.mark + '/' + record.maxMark) : ''
        },
        {
            title: 'Percent',
            dataIndex: 'percentCorrect',
            sorter: false,
            render: (_, record) => record.mark != undefined ? record.percentCorrect + '%' : ''
        },
        {
            title: 'Status',
            dataIndex: 'testAssignmentStatus',
            sorter: false,
            render: (_, record) => {
                return record.testAssignmentStatusDescription;
            }
        },
        {
            title: 'Results',
            dataIndex: 'results',
            sorter: false,
            width: '60%',
            render: (_, record) => {
                if(record.testAssignmentId == undefined || record.userId == undefined) {
                    return <span className="ch-error-text"></span>;
                }
                return <TestResultBarGraph handleOpenDialog={handleOpenDialog} testResult={record}/>;
            }
        }
    ];

    const handleSearch = () => {
        handleBadgeValuesChange();
        setReload(new Date().getTime());
    };

    const handleValuesChange = (changedValues, allValues) => {
        const keys = Object.keys(changedValues);
        const hasOtherKeys = keys.some(key => key !== 'testName' && key !== 'dateRange' && key !== 'studentName');

        if (hasOtherKeys) {
            handleBadgeValuesChange();
        }
        if ('syllabusId' in changedValues || 'syllabusGroupId' in changedValues) {
            handleSearch();
        }
    }

    const handleTestAssignmentStatus = (value) => {
        setTestAssignmentStatus(value);
    };

    // const handleTableChange = (pagination, filters, sorter) => {
    //     let orderBy = 'CREATED_DESC';
    //     if(sorter.field == 'createDate') {
    //         if(sorter.order == 'ascend') {
    //             orderBy = 'CREATED';
    //         } else {
    //             orderBy = 'CREATED_DESC';
    //         }
    //     } else if (sorter.field == 'testName') {
    //         if(sorter.order == 'ascend') {
    //             orderBy = 'NAME';
    //         } else {
    //             orderBy = 'NAME_DESC';
    //         }
    //     } else if (sorter.field == 'assignedDate') {
    //         if(sorter.order == 'ascend') {
    //             orderBy = 'ASSIGNED';
    //         } else {
    //             orderBy = 'ASSIGNED_DESC';
    //         }
    //     }
    //     setOrderBy(orderBy);
    // };

    const fetchData = (pagingParams, handleTableData, handlePagingData, abortController) => {
        const formValues = testResultSearchForm.getFieldsValue();
        const testName = formValues.testName || undefined;
        const studentName = formValues.studentName || undefined;
        const syllabusId = formValues.syllabusId || undefined;
        const [startDate, endDate] = formValues.dateRange || [];
        const clazzId = formValues.classId;

        const payload = {
            pageNumber:  pagingParams.pageNumber,
            pageSize: pagingParams.pageSize,
            testAssignmentStatus: testAssignmentStatus !== 'ALL' ? testAssignmentStatus : undefined,
            testGroupCode: testGroupCode,
            testName: testName,
            studentName: studentName,
            classId: clazzId,
            studentId: studentId,
            syllabusId: syllabusId,
            exam: exam,
            startDate: startDate,
            endDate: endDate
        };

        axios.post('/web/ui/test/teacher/testResults/search', payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            signal: abortController.signal
        }).then(response => {
            const totalResults = response.data.totalResults ?? 0;
            const testsName = brandConfig.testsName.toLowerCase();

            handleTableData(response.data.currPageContents);
            // setTestResults(response.data.currPageContents);
            // setTestResultsCount(response.data.totalResults);
            handlePagingData({
                pageSize: pagingParams.pageSize,
                totalResults: response.data.totalResults ?? 0,
            });

            const resultMessage = totalResults === 1 ? `1 ${brandConfig.testName.toLowerCase()}` : `${totalResults} ${testsName}`;
            setSrAnnouncement(`Table updated. ${resultMessage} found.`);
        })
        .catch(error => {
            console.error('Error loading data:', error);
            handleTableData([]);
            setSrAnnouncement(`Error loading ${brandConfig.testsName.toLowerCase()}. Please try again.`);
        });
    };

    const handleViewTestResult = (testResult) => {
        if (testResult == undefined) {
            message.error('Please select a test result to view.');
            return;
        }

        setTestResultId(testResult.testResultId);
        setVisibleSection('TEST_RESULT');
    };

    const handleChangeTestGroup = (value) => {
        setTestGroupCode(value);
    };

    const handleCloseTestResult = () => {
        setTestResultId(undefined);
        setVisibleSection('TEST_RESULTS');
    };


    return (
        <>
            <LiveRegion message={srAnnouncement} />
            <div className={'js-testResultSearch' + (visibleSection != 'TEST_RESULTS' ? ' ch-hide' : '')}>
                <div>
                    <TableFilterControls
                        filterCount={activeFilterCount}
                        showFilterButton={true}
                        primaryFilterItem={
                            <Form.Item label={brandConfig.testsName}>
                                <Select
                                    aria-label="assessment result status"
                                    value={testAssignmentStatus}
                                    onChange={handleTestAssignmentStatus}
                                    style={{ width: 180 }}
                                >
                                    <Select.Option value="ALL">
                                        All
                                    </Select.Option>
                                    <Select.Option value="STARTED">
                                        Started
                                    </Select.Option>
                                    <Select.Option value="COMPLETED">
                                        Completed
                                    </Select.Option>
                                    <Select.Option value="EXPIRED">
                                        Expired
                                    </Select.Option>
                                    <Select.Option value="ABANDONED">
                                        Abandoned
                                    </Select.Option>
                                    <Select.Option value="TIMED_OUT">
                                        Timed-out
                                    </Select.Option>
                                </Select>
                            </Form.Item>
                        }
                        filterContent={
                            <TableFilterControlsForm
                                form={testResultSearchForm}
                                onFinish={handleSearch}
                                onValuesChange={handleValuesChange}
                                initialValues={{ nameSearch: '' }}
                                useApplyButton={true}
                            >
                                <TableFilterControlsSection>
                                    <Form.Item label={`${brandConfig.testName} name`} name="testName">
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Class" name="classId">
                                        <ClassSelect
                                            classes={user.classes}
                                            width={'100%'}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Date range" name="dateRange">
                                        <RangePicker format={user.getDateFormatString()} style={{width: '100%'}} />
                                    </Form.Item>
                                    <Form.Item name="examCategory" label="Content category">
                                        <Select
                                            mode="multiple"
                                            value={exam ? ['exam'] : []}
                                            onChange={(values) => setExam(values.includes('exam'))}
                                            placeholder="Select content category"
                                            allowClear={true}
                                        >
                                            <Select.Option value="exam">Exams</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </TableFilterControlsSection>
                                <TableFilterControlsSection>
                                    <SyllabusTopicConceptSelect
                                        form={testResultSearchForm}
                                        selectLevel="syllabus"
                                        defaultLevel="syllabusGroup"
                                        onLoadComplete={onLoadComplete}
                                    />
                                </TableFilterControlsSection>
                                <TableFilterControlsSection showDivider={false}>
                                    <Form.Item label="Student" name="studentId">
                                        <Select
                                            allowClear={true}
                                            placeholder="Select a student"
                                            value={studentId}
                                            onChange={(value) => setStudentId(value)}
                                            options={students.map((student) => ({
                                                value: student.userId,
                                                label: student.firstName + " " + student.lastName,
                                            }))}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Student Name" name="studentName">
                                        <Input />
                                    </Form.Item>
                                    {brandConfig.testGroupCodes &&
                                        <Form.Item label={brandConfig.testName + " group"} name="testGroupCode">
                                            <Select
                                                loading={isTestGroupsLoading}
                                                placeholder="Select group"
                                                allowClear={true}
                                                onChange={handleChangeTestGroup}
                                            >
                                                {testGroups.map((item) => (
                                                    <Option
                                                        key={item.testGroupCode}
                                                        value={item.testGroupCode}
                                                    >
                                                        {item.testGroupName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    }
                                </TableFilterControlsSection>
                            </TableFilterControlsForm>
                        }/>
                    <TableAntD
                        dynamicWidth={true}
                        pagingDependencies={[reload, classId, exam, testAssignmentStatus, testGroupCode, studentId]}
                        pagingData={{ fetchFunction: fetchData, params: { pageSize: 10, currentPage: 1}}}
                        columnData={columns}
                        rowKey="testResultId"
                        // onChange={handleTableChange}
                        locale={{
                            emptyText: (
                                <span className="ch-warning-text">No {brandConfig.testName.toLowerCase()} results found</span>
                            )
                        }}
                    />
                </div>
            </div>
            {testResultId != undefined  && visibleSection == 'TEST_RESULT' &&
                <TestResult testResultId={testResultId} handleBack={handleCloseTestResult}/>
            }
            <GenericDialog open={questionResultDialogOpen}
                           title="Test question"
                           onClose={() => {
                               setQuestionResultDialogOpen(false);
                           }}
                           buttons={[{name: 'Close'}]}>
                <TestQuestion questionResult={questionResult} testQuestion={question} showExamCitations={false} showUserAnswers={true} />
            </GenericDialog>
        </>
    );
};

export default TeacherTestResults;